import { createAction } from "redux-starter-kit";
import { SET_MEDIAS_ACTION, SET_MEDIAS_USED_ACTION } from "../actionTypes";
import { getMediasApi } from "../../api/issues";

export const setMediasAction = createAction(SET_MEDIAS_ACTION);
export const setMediaUsedAction = createAction(SET_MEDIAS_USED_ACTION);

export function loadMediasRequestAction(issueID, toast) {
  if (issueID == null) {
    return;
  }

  return async dispatch => {
    dispatch(setMediasAction({ medias: null }));

    let promiseArr = [
      getMediasApi(issueID, true, true),
      getMediasApi(issueID, true, false)
    ];

    let returnArr = [];

    try {
      const result = await Promise.all(promiseArr).catch(e => {
        throw e;
      });

      for (let i = 0; i < result.length; i++) {
        for (let j = 0; j < result[i].length; j++) {
          const item = result[i][j];

          item.mediaType = i === 0 ? "video" : "audio";

          returnArr.push(item);
        }
      }
    } catch (e) {
      toast.error(e.toString);
    }

    dispatch(setMediasAction({ medias: returnArr }));
  };
}
